export default `
<style type="text/css">
	.google__0{fill:#4285F4;}
	.google__1{fill:#34A853;}
	.google__2{fill:#FBBC05;}
	.google__3{fill:#EA4335;}
</style>
<g id="Sign-up-_x2F_-Sign-in">
	<g id="Sign-up" transform="translate(-705.000000, -616.000000)">
		<g id="sign-in" transform="translate(640.000000, 170.000000)">
			<g id="social-buttons" transform="translate(20.000000, 433.000000)">
				<g id="google">
					<g id="logo_googleg_48dp" transform="translate(45.000000, 13.000000)">
						<path id="Shape" class="google__0" d="M23.8,12.3c0-0.9-0.1-1.7-0.2-2.5H12.3v4.6h6.5c-0.3,1.5-1.1,2.8-2.4,3.6v3h3.9
							C22.5,19,23.8,15.9,23.8,12.3L23.8,12.3z"/>
						<path id="Shape_1_" class="google__1" d="M12.3,24c3.2,0,6-1.1,7.9-2.9l-3.9-3c-1.1,0.7-2.4,1.1-4.1,1.1c-3.1,0-5.8-2.1-6.7-4.9h-4
							v3.1C3.5,21.3,7.6,24,12.3,24L12.3,24z"/>
						<path id="Shape_2_" class="google__2" d="M5.5,14.3c-0.2-0.7-0.4-1.5-0.4-2.3s0.1-1.6,0.4-2.3V6.6h-4C0.7,8.2,0.3,10.1,0.3,12
							s0.5,3.8,1.3,5.4L5.5,14.3L5.5,14.3z"/>
						<path id="Shape_3_" class="google__3" d="M12.3,4.8c1.8,0,3.3,0.6,4.6,1.8l3.4-3.4c-2.1-1.9-4.8-3.1-8-3.1C7.6,0,3.5,2.7,1.5,6.6
							l4,3.1C6.5,6.9,9.1,4.8,12.3,4.8L12.3,4.8z"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>`;
